import { render, staticRenderFns } from "./DirectorioV2.html?vue&type=template&id=fdb27d7a&scoped=true&"
import script from "./DirectorioV2.js?vue&type=script&lang=js&"
export * from "./DirectorioV2.js?vue&type=script&lang=js&"
import style0 from "./DirectorioV2.scss?vue&type=style&index=0&id=fdb27d7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb27d7a",
  null
  
)

export default component.exports